export type ImageServiceConfig = {
	dreadnoughtImageUrl: string;
	cdnImageUrl: string;
};

export class ImageService {
	static readonly IMAGE_PARAMS = "?format=auto&compress=true&q=50";

	readonly #dreadnoughtImageUrl: string;
	readonly #cdnImageUrl: string;

	constructor(config: ImageServiceConfig) {
		this.#dreadnoughtImageUrl = this.#cleanUrl(config.dreadnoughtImageUrl);
		this.#cdnImageUrl = this.#cleanUrl(config.cdnImageUrl);
	}

	#cleanUrl(url: string) {
		if(!url.endsWith("/")) {
			return url + "/";
		}

		return url;
	}

	#makeParams(width: number | undefined | null): string {
		return width
			? ImageService.IMAGE_PARAMS + "&w=" + width
			: ImageService.IMAGE_PARAMS;
	}

	#makeSrc(baseUrl: string, imageId: string | undefined | null, width: number | undefined | null): string | undefined {
		if(!imageId) {
			return undefined;
		}
		return baseUrl + imageId + ".jpg" + this.#makeParams(width);
	}

	get cdnImageUrl(): string {
		return this.#cdnImageUrl;
	}

	getSrc(imageId: string | undefined | null, width?: number | undefined | null): string | undefined {
		return this.#makeSrc(this.#cdnImageUrl, imageId, width);
	}

	getDreadnoughtSrc(imageId: string | undefined | null, width?: number | undefined | null): string | undefined {
		return this.#makeSrc(this.#dreadnoughtImageUrl, imageId, width);
	}
}
